import { render, staticRenderFns } from "./DepartmentSearchBarComponent.vue?vue&type=template&id=412d5286"
import script from "./DepartmentSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./DepartmentSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSearchBarComponent.vue?vue&type=style&index=0&id=412d5286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports